import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../context/AlertContext";
import { ServiciosContext } from "../../context/ServiciosContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { ThemeProvider, createMuiTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Spinner from "./Spinner";
import { AuthContext } from "../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { saveAs } from "file-saver";
import Menu from "./Menu";
import { InputMask } from "primereact/inputmask";
import { InputNumber } from "primereact/inputnumber";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { SelectButton } from "primereact/selectbutton";

export default function Presupuestos(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID Presupuesto", dataKey: "id_presupuesto" },
    { title: "Concepto", dataKey: "concepto" },
    { title: "Presupuestado", dataKey: "importe" },
  ];

  const [concepto, guardarConcepto] = useState(null);
  const [visible, setVisible] = useState(false);
  const [detalle, guardarDetalle] = useState(null);
  const [fecha, guardarFecha] = useState(null);
  const [periodo1, guardarPeriodo1] = useState(null);
  const [periodo2, guardarPeriodo2] = useState(null);
  const [periodo3, guardarPeriodo3] = useState(null);

  const toast = useRef(null);

  let { sector } = useParams();

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    conceptos,
    conceptosSector,
    conceptosSectorPeriodo,
    periodoPresupuesto,
    obtenerConceptos,
    obtenerConceptosSector,
    obtenerConceptosSectorPeriodo,
    obtenerAcceso,
    obtenerAcceso2,
    agregarConceptoPresupuesto,
    actualizarConceptoPresupuesto,
    obtenerPeriodoPresupuesto,
    actualizarPeriodoPresupuesto,
    guardarPeriodoPresupuesto,
    eliminarConceptoPresupuesto,
  } = configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      if (sector && sector === "administracion") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoAdministracion",
        });
      }
      /*
      if (sector && sector === "cobranzas") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoCobranzas",
        });
      }
      if (sector && sector === "operaciones") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoOperaciones",
        });
      }
      if (sector && sector === "compras") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoCompras",
        });
      }
      if (sector && sector === "personal") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoRRHH",
        });
      }
      if (sector && sector === "tesoreria") {
        obtenerAcceso({
          usuarioId: state.usuario.id,
          layout: "PresupuestoTesoreria",
        });
      }
      */
      if (sector && sector === "periodo") {
        obtenerAcceso2({
          usuarioId: state.usuario.id,
          layout: "PeriodoPresupuesto",
        });
      }
    }
  }, [state]);

  useEffect(() => {
    if (sector) {
      obtenerPeriodoPresupuesto();
      obtenerConceptos();
    }
  }, [sector]);

  useEffect(() => {
    if (periodoPresupuesto) {
      let periodo1 = calcularPeriodoAnterior(periodoPresupuesto.periodo);
      let periodo2 = calcularPeriodoAnterior(periodo1);
      let periodo3 = calcularPeriodoAnterior(periodo2);
      obtenerConceptosSector({
        sector,
        periodo: periodoPresupuesto.periodo,
        periodo1,
        periodo2,
        periodo3,
      });
      guardarPeriodo1(periodo1);
      guardarPeriodo2(periodo2);
      guardarPeriodo3(periodo3);
    }
  }, [periodoPresupuesto]);

  const datosAplanados = conceptosSector.map((item) => ({
    "conceptos.id_presupuesto": item.conceptos?.id_presupuesto,
    "conceptos.nombre": item.conceptos?.nombre,
    importe: Number(item.importe).toLocaleString("en-US", {
      minimumFractionDigits: 2,
    }),
  }));

  function calcularPeriodoAnterior(periodo) {
    // 1. Separar el mes y el año del string (ej: "01/26")
    const [mesStr, añoStr] = periodo.split("/");

    // 2. Crear un objeto Date (usamos el día 1 por defecto)
    // Nota: El año se suma a 2000 para obtener el año completo (ej: 2026)
    // El mes en JS es base 0 (0 = enero), por eso restamos 1
    let fecha = new Date(parseInt("20" + añoStr), parseInt(mesStr) - 1, 1);

    // 3. Restar un mes
    fecha.setMonth(fecha.getMonth() - 1);

    // 4. Formatear de vuelta a MM/YY
    let mesAnterior = (fecha.getMonth() + 1).toString().padStart(2, "0");
    let añoAnterior = fecha.getFullYear().toString().slice(-2);

    return `${mesAnterior}/${añoAnterior}`;
  }

  const editClick = (e) => {
    if (selectedRow) {
      selectedRow.importe = selectedRow.importe.replaceAll(",", "");
      guardarConcepto(selectedRow);
      setVisible(true);
    } else {
      toast.current.show({
        severity: "info",
        summary: "Editar",
        detail: "Debe seleccionar un concepto.",
        life: 3000,
      });
    }
  };

  const eliminarClick = (e) => {
    if (selectedRow) {
      confirmDialog({
        message:
          "Desea eliminar el concepto " +
          selectedRow.concepto +
          " de $" +
          selectedRow.importe +
          " ?.",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "No",
        acceptLabel: "Si",
        accept: () => acceptEliminar(),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar un concepto.",
        life: 3000,
      });
    }
  };

  const acceptEliminar = () => {
    eliminarConceptoPresupuesto({ selectedRow });
    setSelectedRow(null);
    setTimeout(() => {
      obtenerConceptosSector({
        sector,
        periodo: periodoPresupuesto.periodo,
        periodo1,
        periodo2,
        periodo3,
      });
    }, 2000);
  };

  const addClick = (e) => {
    //props.history.push(`/concepto/0`);
    setVisible(true);
    setSelectedRow(null);
    guardarConcepto(null);
  };

  const confirmarPeriodo = (e) => {
    e.preventDefault();
    //Validar

    if (
      !periodoPresupuesto ||
      periodoPresupuesto.periodo === undefined ||
      periodoPresupuesto.periodo === null ||
      periodoPresupuesto.periodo.trim() === ""
    ) {
      mensajeAlerta("Presupuesto", "El período es necesario !.", "error");
      return;
    }

    if (
      !periodoPresupuesto ||
      periodoPresupuesto.porcentaje === undefined ||
      periodoPresupuesto.porcentaje === null ||
      Number(periodoPresupuesto.porcentaje) <= 0
    ) {
      mensajeAlerta(
        "Presupuesto",
        "El porcentaje de alerta es necesario !.",
        "error",
      );
      return;
    }
    actualizarPeriodoPresupuesto({ periodoPresupuesto });
    navigate("/");
  };

  const exitClick = (e) => {
    navigate("/");
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar

    if (
      !concepto ||
      concepto.id_concepto === undefined ||
      concepto.id_concepto === null ||
      concepto.id_concepto === ""
    ) {
      mensajeAlerta("Presupuesto", "Concepto es necesario !.", "error");
      return;
    }

    if (
      !concepto ||
      concepto.importe === undefined ||
      concepto.importe === null ||
      concepto.importe === "" ||
      Number(concepto.importe < 0)
    ) {
      mensajeAlerta("Presupuesto", "Importe es necesario !.", "error");
      return;
    }



    // Llamar al context

    if (selectedRow) {
      actualizarConceptoPresupuesto({ concepto, periodoPresupuesto, sector });
    } else {
      agregarConceptoPresupuesto({
        concepto,
        periodoPresupuesto,
        sector,
      });
    }
    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerConceptosSector({
        sector,
        periodo: periodoPresupuesto.periodo,
        periodo1,
        periodo2,
        periodo3,
      });
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Presupuesto",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const habilitadoTemplate = (rowData) => {
    return (
      <Fragment>
        <Checkbox checked={rowData.habilitado}></Checkbox>
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.setFontSize(12);
        doc.text(
          `Listado de conceptos de ${sector} del período ${periodoPresupuesto.periodo}`,
          30,
          8,
        );

        doc.setFontSize(10);
        doc.autoTable(
          exportColumns,
          conceptosSector.filter((fila) => {
            // Condición para mantener la fila (ej: no incluir si es una fila de totales o un ID específico)
            return Number(fila.importe) !== 0;
          }),
          {
            columnStyles: {
              2: {
                halign: "right",
              },
            },
            didParseCell: (data) => {
              if (data.cell && data.cell.section === "head") {
                switch (data.cell.raw) {
                  case "Presupuestado":
                    data.cell.styles.halign = "right";
                    break;
                  default:
                    data.cell.styles.halign = "left";
                    break;
                }
              }
            },
          },
        );
        window.open(doc.output("bloburl"));
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(conceptos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "conceptos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const header = (
    <Fragment>
      <div className="p-d-flex export-buttons">
        <span
          style={{ marginLeft: "1em", marginRight: "1em" }}
          className="p-input-icon-left"
        >
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Buscar"
          />
        </span>
        <Tag
          value={
            periodoPresupuesto && sector
              ? "Presupuesto Período " +
                periodoPresupuesto.periodo +
                " (" +
                sector.toUpperCase() +
                ")"
              : "Presupuesto"
          }
        ></Tag>
      </div>
    </Fragment>
  );

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Concepto"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(sector);
  //console.log(conceptos);

  return (
    <Fragment>
      <Menu />
      <ConfirmDialog />
      <Toast ref={toast} />
      {sector && sector === "periodo" ? (
        <Fragment>
          {statusAcceso2 === 0 ? <Spinner /> : null}
          {statusAcceso2 === 400 ? accesoDenegado() : null}
          {statusAcceso2 === 200 ? (
            <Fragment>
              <Grid container spacing={3} style={{ margin: "5vw" }}>
                <Grid item xs={12} md={3}>
                  <label htmlFor="id">Período Activo</label>
                  <InputMask
                    id="periodo"
                    mask="99/99"
                    value={
                      periodoPresupuesto ? periodoPresupuesto.periodo : null
                    }
                    placeholder="99/99"
                    //onBlur={handleEnter}
                    size={4}
                    onChange={(e) =>
                      guardarPeriodoPresupuesto({
                        ...periodoPresupuesto,
                        periodo: e.value,
                      })
                    }
                    style={{ marginLeft: "0.7vw", marginTop: "0.4vw" }}
                  ></InputMask>
                </Grid>
                <Grid item xs={12} md={9} />

                <Grid item xs={12} md={2}>
                  <TextField
                    value={
                      periodoPresupuesto ? periodoPresupuesto.porcentaje : null
                    }
                    id="porcentaje"
                    label="% Alerta"
                    fullWidth
                    required
                    size="normal"
                    type="number"
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarPeriodoPresupuesto({
                        ...periodoPresupuesto,
                        porcentaje: e.target.value,
                      })
                    }
                  />
                  <Grid item xs={12} md={10} />

                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{ paddingLeft: 0, marginTop: "2vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={
                            periodoPresupuesto
                              ? periodoPresupuesto.editarIngresos
                              : null
                          }
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarPeriodoPresupuesto({
                              ...periodoPresupuesto,
                              editarIngresos: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Editar Ingresos"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ paddingLeft: 0, marginTop: "2vw" }}
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Checkbox
                          color="primary"
                          checked={periodoPresupuesto ? periodoPresupuesto.editarGastos : null}
                          style={{ marginLeft: "1vw" }}
                          onChange={(e) =>
                            guardarPeriodoPresupuesto({
                              ...periodoPresupuesto,
                              editarGastos: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Editar Gastos"
                      labelPlacement="start"
                      style={{ paddingLeft: ".7vw" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12} md={11} />
                <Grid item xs={12} md={12} />

                <ButtonMui
                  type="button"
                  variant="contained"
                  color="primary"
                  onClick={confirmarPeriodo}
                  style={{ marginTop: "1vw" }}
                >
                  Confirmar
                </ButtonMui>
                <ButtonMui
                  type="button"
                  variant="contained"
                  color="secondary"
                  onClick={exitClick}
                  style={{ marginLeft: "1vw", marginTop: "1vw" }}
                >
                  Salir
                </ButtonMui>
              </Grid>
            </Fragment>
          ) : null}
        </Fragment>
      ) : null}

      {sector && sector !== "periodo" && statusAcceso === 200 ? (
        <Fragment>
          {statusAcceso === 0 ? <Spinner /> : null}
          {statusAcceso === 400 ? accesoDenegado() : null}
          {statusAcceso === 200 ? (
            <Fragment>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                style={{ align: "center", margin: "1em" }}
              >
                <Button
                  icon="pi pi-plus"
                  tooltip="Agregar Conceptos"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "0em" }}
                  onClick={addClick}
                />
                <Button
                  icon="pi pi-pencil"
                  tooltip="Editar"
                  className="p-button-rounded p-button-warning"
                  style={{ marginLeft: "1em" }}
                  onClick={editClick}
                />
                <Button
                  icon="pi pi-trash"
                  tooltip="Eliminar"
                  className="p-button-rounded p-button-danger"
                  style={{ marginLeft: "1em" }}
                  onClick={eliminarClick}
                />
                <Button
                  id="pdf"
                  icon="pi pi-file-pdf"
                  tooltip="Pdf"
                  className="p-button-rounded p-button-help"
                  style={{ marginLeft: "1em" }}
                  onClick={exportPdf}
                />

                <Button
                  icon="pi pi-times"
                  tooltip="Cerrar"
                  className="p-button-rounded p-button-primary"
                  style={{ marginLeft: "1em" }}
                  onClick={exitClick}
                />
                <div className="datatable-responsive-demo">
                  <div className="card">
                    <Tooltip
                      target=".export-buttons>button"
                      position="bottom"
                    />
                    <DataTable
                      value={conceptosSector}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      header={header}
                      className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-demo"
                      style={{ fontSize: "small", marginTop: "1vw" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={500}
                      rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        //body={idTemplate}
                        sortable
                        style={{ display: "none" }}
                      ></Column>
                      <Column
                        field="id_presupuesto"
                        header="ID Presupuesto"
                        //body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="concepto"
                        header="Concepto"
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="importe3"
                        header={`Pres. ${periodo3}`}
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="importe2"
                        header={`Pres. ${periodo2}`}
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="importe1"
                        header={`Pres. ${periodo1}`}
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="importe"
                        header={
                          periodoPresupuesto
                            ? `Pres. ${periodoPresupuesto.periodo}`
                            : null
                        }
                        //body={descripcionTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                  </div>
                </div>
              </Grid>

              <Dialog
                header={renderHeader()}
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  <Grid item xs={12} md={10} style={{ marginLeft: "1vw" }}>
                    <Autocomplete
                      id="concepto"
                      fullWidth
                      noOptionsText={"No hay opciones"}
                      options={
                        conceptos
                          ? conceptos.filter(
                              (item) =>
                                item.habilitado &&
                                item.id_presupuesto &&
                                Number(item.id_presupuesto) != 0,
                            )
                          : null
                      }
                      value={
                        concepto && conceptos
                          ? conceptos[
                              conceptos.findIndex(
                                (item) => item.id === concepto.id_concepto,
                              )
                            ]
                          : null
                      }
                      disabled={selectedRow}
                      getOptionLabel={(option) => option.nombre}
                      openOnFocus={true}
                      disablePortal
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Concepto"
                          variant="standard"
                        />
                      )}
                      //onKeyDown={handleEnter}
                      onChange={(event, value) => {
                        if (value) {
                          guardarConcepto({
                            ...concepto,
                            id_concepto: value.id,
                            concepto: value.nombre,
                          });
                        } else {
                          guardarConcepto({
                            ...concepto,
                            id_concepto: null,
                            concepto: null,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={5}>
                    <label
                      style={{
                        marginLeft: "1vw",
                        fontSize: "medium",
                      }}
                      htmlFor="importe"
                    >
                      Presupuestado:
                    </label>
                    <InputNumber
                      inputId="importe"
                      value={concepto ? concepto.importe : null}
                      onChange={(e) => {
                        if (e.value) {
                          guardarConcepto({
                            ...concepto,
                            importe: e.value,
                          });
                        } else {
                          guardarConcepto({
                            ...concepto,
                            importe: 0,
                          });
                        }
                      }}
                      size={12}
                      mode="decimal"
                      locale="en-US"
                      minFractionDigits={2}
                      style={{
                        marginLeft: "0.7vw",
                        marginTop: "0.8vw",
                      }}
                    />
                  </Grid>
                </Grid>
              </Dialog>

              <Grid item xs={12} sm={12}></Grid>
            </Fragment>
          ) : null}
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
